/** Accordion **/
window.addEventListener('DOMContentLoaded', function () {
    const accordions = [...document.querySelectorAll('.accordion')]
  
    if (accordions && accordions.length > 0) {
      accordions.forEach((each) => {
        const items = [...each.querySelectorAll('.accordion-item')]
  
        if (items && items.length > 0) {
          items.forEach(function (each2) {
            closeAllAccordionitems(items)
            const header = each2.querySelector('.accordion-item-header')
            const body = each2.querySelector('.accordion-item-content')
  
            header.addEventListener('click', function (e) {
              e.preventDefault()
  
              if (header.classList.contains('accordion-item-header--opened') && body.classList.contains('accordion-item-content--opened')) {
                closeAllAccordionitems(items)
              } else {
                closeAllAccordionitems(items)
                header.classList.add('accordion-item-header--opened')
                body.classList.add('accordion-item-content--opened')
                openAccordionContent(body)
              }
            })
          })
  
          const opened = each.dataset.opened;
          if (opened !== "false") {
            activateFirstAccordionItem(items[0]);
          }
        }
      })
    }
  })
  
  function closeAllAccordionitems(mainAccordion) {
    if (mainAccordion && mainAccordion.length > 0) {
      mainAccordion.forEach(function (each) {
        const innerHeader = each.querySelector('.accordion-item-header')
        const innerBody = each.querySelector('.accordion-item-content')
  
        innerHeader.classList.remove('accordion-item-header--opened')
        // innerHeader.classList.remove('careBody--left--head__open')
        innerBody.classList.remove('accordion-item-content--opened')
  
        closeAccordionContent(innerBody)
      })
    }
  }
  
  function activateFirstAccordionItem(accordionItem) {
    if (accordionItem) {
      const innerHeader = accordionItem.querySelector('.accordion-item-header')
      const innerBody = accordionItem.querySelector('.accordion-item-content')
  
      innerHeader.classList.add('accordion-item-header--opened')
      // innerHeader.classList.add('careBody--left--head__open')
      innerBody.classList.add('accordion-item-content--opened')
      openAccordionContent(innerBody)
    }
  }
  
  function openAccordionContent(contentWrapper) {
    if (contentWrapper) {
      const content = contentWrapper.querySelector('.accordion-item-body')
  
      if (content) {
        contentWrapper.style.height = content.scrollHeight + 'px'
      }
    }
  }
  
  function closeAccordionContent(contentWrapper) {
    if (contentWrapper) {
      contentWrapper.style.height = '0px';
    }
  }
/** End - Accordion */
  